/**
 * Type guard and interface for alert preview data.
 * Used to detect when tool results contain alert config data that should
 * auto-expand and render via the AlertPreviewDisplay component.
 *
 * Mirrors graphPreviewData.ts — the observability package owns the
 * rendering component; this lives in vega so the AgentInsights chrome can
 * decide auto-expand without depending on observability.
 */

export interface AlertPreviewData {
  kind: 'alert_preview';
  name: string;
  product_type: string;
  query: string;
  function_type: string;
  function_column: string;
  group_by_keys: string[] | null;
  threshold_type: string;
  threshold_condition: string;
  threshold_value: number;
  threshold_window_seconds: number;
  threshold_cooldown_seconds: number;
  evaluation_delay_seconds: number;
  bucket_by_key: string;
  bucket_count: number | null;
  bucket_window_seconds: number | null;
  project_id?: string | null;
}

export const isAlertPreviewData = (data: unknown): data is AlertPreviewData => {
  const d = data as AlertPreviewData;
  return (
    d != null &&
    d.kind === 'alert_preview' &&
    typeof d.name === 'string' &&
    typeof d.product_type === 'string' &&
    typeof d.threshold_value === 'number' &&
    typeof d.threshold_window_seconds === 'number'
  );
};
